import React from "react";
import { Link } from "react-router-dom";
//
import logo from "../../../Lealtad/assets/logo/logo2.png";
//
import { FaUserAlt } from "react-icons/fa";
import { FaHandsHelping, FaClipboardList } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhoneLealtad = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucellealtad">
      <div>
        <div className="boxlogophonemenulealtad">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcellealtad">
              <FaUserAlt className="phoneiconlealtad" />
              Perfil
            </p>
          </div>
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Factura")}
          >
            <p className="textcellealtad">
              <FaHandsHelping className="phoneiconlealtad" />
              Subir factura
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <Link to="/portal-proveedor-lealtad/mis-facturas">
            <div className="boxbuttonprovlealtad">
              <p className="letterbuttonprovlealtad">
                <FaClipboardList className="iconprovlealtad" />
                Mis facturas
              </p>
            </div>
          </Link>
        </div>

        <div className="flexbuttonsphonelealtad">
          <div className="buttonsphonelealtad buttonfinallealtad">
            <p className="textcellealtad">
              <RiLockPasswordFill className="phoneiconlealtad" />
              Cambiar <br /> contraseña
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad buttonfinallealtad"
            onClick={handleLogout}
          >
            <p className="textcellealtad">
              <FaDeleteLeft className="phoneiconlealtad" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhoneLealtad;
